import React from 'react';

export const Sar = ({ className = '' }) => (
  <span className={`icon-saudi_riyal_bold ${className}`} />
);
